import Requests from '@/helpers/Request';
import Vue from 'vue';
import Vuex from 'vuex';
import customizer from './modules/customizer';
import device from './modules/device';
import notification from './modules/notification';
import socket from './modules/socket';
//import logger from './modules/socket-logger';
import playback from './modules/playback';
import tv from './modules/tv';
import radio from './modules/radio';
import lang from './modules/lang';
import navigation from './modules/navigation';
import vod from './modules/vod';
import welcome from './modules/welcome';
import epgGuide from './modules/epg-guide';
import epgGuide2 from './modules/epg-guide2';
import epgNow from './modules/epg-now';
import cast from './modules/cast';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    device: device,
    customizer: customizer,
    notification: notification,
    socket: socket,
    //logger: logger,
    playback: playback,
    tv,
    radio,
    navigation,
    vod,
    lang,
    welcome,
    epgGuide,
    epgGuide2,
    epgNow,
    cast
  },
  state: {
    buildingId: null,
    groupId: null,
    deviceId: null,
    hash: null,
    timeInterval: null,
    currentTime: new Date(),
    appMenu: [
      {
        type: 'internal',
        buildingId: 2,
        imgBaseUrl: process.env.PORTAL,
        imgUrl: '/images/thumbnail/tb_weather.jpg',
        ident: 'weather',
        url:
          '#iFrame/https://stagingweatherapp.triax.biz/?c1=Paris&c2=Rom&c3=London&s=Berlin&d=4&yc=es&c1c=fr&c2c=it&c3c=gb',
        lang: {
          el: {
            title: 'Καιρός',
            description: 'Ο σημερινός τοπικός καιρός',
          },
          pt: {
            title: 'Weather',
            description: 'The current local weather',
          },
          hu: {
            title: 'Időjárás',
            description: 'Aktuális helyi időjárás',
          },
          da: {
            title: 'Vejret',
            description: 'Lokalt vejr',
          },
          sv: {
            title: 'Väder',
            description: 'Det aktuella lokala vädre',
          },
          en: {
            title: 'Weather',
            description: 'The current local weather',
          },
          de: {
            title: 'Wetter',
            description: 'Das aktuelle lokale Wetter',
          },
          ch_de: {
            title: 'Wetter',
            description: 'Das aktuelle lokale Wetter',
          },
          ch_fr: {
            title: 'Météo',
            description: 'La météo locale actuelle',
          },
          ch_it: {
            title: 'Meteo',
            description: 'Meteo locale attuale',
          },
          ru: {
            title: 'Погода',
            description: 'Прогноз погоды',
          },
          es: {
            title: 'El tiempo',
            description: 'El tiempo actual',
          },
          ar: {
            title: 'الطقس',
            description: 'الطقس المحلي الحالي',
          },
          fr: {
            title: 'Météo',
            description: 'La météo locale actuelle',
          },
          tr: {
            title: 'Hava durumu',
            description: 'Güncel Hava durumu',
          },
          ea: {
            title: 'Weather',
            description: 'The current local weather',
            logo_url: '/build/images/tb5_weather3.jpg',
            url:
              '#iFrame/https://stagingweatherapp.triax.biz?c1=Paris&c2=Rom&c3=London&s=Berlin&d=4&yc=de&c1c=fr&c2c=it&c3c=gb&lang=ea',
          },
          ge: {
            title: 'Wetter',
            description: 'Das aktuelle lokale Wetter',
            logo_url: '/build/images/tb5_weather3.jpg',
            url:
              '#iFrame/https://stagingweatherapp.triax.biz?c1=Paris&c2=Rom&c3=London&s=Berlin&d=4&yc=de&c1c=fr&c2c=it&c3c=gb&lang=ea',
          },
          it: {
            title: 'Meteo',
            description: 'Meteo locale attuale',
          },
          nl: {
            title: 'Het weer',
            description: 'Het huidige locale weer',
          },
          ko: {
            title: '날씨',
            description: '현재 지역 날씨',
          },
        },
        platform: ['tv'],
        tags: '',
        configUrl: '',
        status: false,
        order: 27,
        default: true,
        title: 'Weather',
        id: '5bdb46fd76586d000ff12be6',
      },
    ],
    isLoadedState: false,
  },
  mutations: {
    setAppMenu(state, context) {
      state.appMenu = context;
    },
    setGlobalValues(state, context) {
      for (const item in context) {
        state[item] = context[item];
      }
    },
    setTimeInterval(state) {
      state.timeInterval = setInterval(() => {
        state.currentTime = new Date();
      }, 500);
    },
    setIsLoadedState(state, value = true) {
      state.isLoadedState = value;
    },
  },
  actions: {
    initGlobalValues({ commit }, context) {
      console.log('GLOBAL', context);
      commit('setGlobalValues', context);
      commit('setTimeInterval');
      return Promise.resolve();
    },
    unsignEventListeners({ state }) {
      clearInterval(state.timeInterval);
    },
    async fetchAppMenu({ state, commit }) {
      const response = await Requests.get(
        `${process.env.API_PORTAL}/bid/${state.buildingId}/appmenu`
      ).catch((err) => {
        console.log(
          "Couldn't fetch app menu because of Error: ",
          err.name,
          ' with Message: ',
          err.message
        );
        return [];
      });
      commit('setAppMenu', response);
      return Promise.resolve();
    },
  },
  getters: {
    getAppMenu(state) {
      return state.appMenu
        .filter((e) => e.status && e.ident !== 'options')
        .sort((a, b) => (a.order > b.order ? 1 : -1));
    },
    getTimeString() {
      let options = {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
      };
      //var locale = window.navigator.userLanguage || window.navigator.language;
      return this.time.toLocaleString('de-DE', options);
    },
    getHeaderTimeDate(state) {
      let options = {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
      };
      //var locale = window.navigator.userLanguage || window.navigator.language;
      return state.currentTime.toLocaleString('de-DE', options);
    },
    getHeaderTime: (state) => (dateISO) => {
      let options = {
        hour: '2-digit',
        minute: '2-digit',
      };
      var locale = dateISO || window.navigator.userLanguage || window.navigator.language || 'default';
      return state.currentTime.toLocaleString(locale, options);
    },
    getHeaderDate: (state) => (dateISO) => {
      let options = {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: '2-digit',
      };
      var locale = dateISO || window.navigator.userLanguage || window.navigator.language || 'default';
      return state.currentTime.toLocaleString(locale, options);
    },
  },
});

if (module.hot) {
  // accept actions and mutations as hot modules
  module.hot.accept(
    [
      './modules/customizer',
      './modules/device',
      './modules/notification',
      './modules/socket',
      //'./modules/socket-logger',
      './modules/playback',
      './modules/tv',
      './modules/radio',
      './modules/navigation',
      './modules/vod',
      './modules/lang',
      './modules/welcome',
    ],
    () => {
      // require the updated modules
      // have to add .default here due to babel 6 module output
      // const newMutations = require('./mutations').default;
      const newCustomizer = require('./modules/customizer').default;
      const newDeviceInfo = require('./modules/device').default;
      const newNotification = require('./modules/notification').default;
      const newSocket = require('./modules/socket').default;
      //const newLogger = require('./modules/socket-logger').default;
      const newPlayback = require('./modules/playback').default;
      const newTV = require('./modules/tv').default;
      const newRadio = require('./modules/radio').default;
      const newNavigation = require('./modules/navigation').default;
      const newVod = require('./modules/vod').default;
      const newLang = require('./modules/lang').default;
      const newWelcome = require('./modules/welcome').default;
      // swap in the new modules and mutations
      store.hotUpdate({
        modules: {
          customizer: newCustomizer,
          device: newDeviceInfo,
          notification: newNotification,
          socket: newSocket,
          //logger: newLogger,
          playback: newPlayback,
          tv: newTV,
          radio: newRadio,
          navigation: newNavigation,
          vod: newVod,
          lang: newLang,
          welcome: newWelcome,
        },
      });
    }
  );
}

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js